<template>
  <MeasureGraphContainer :id="$route.params.id">
    <div
      slot-scope="{
        measure,
        shapes,
        dataset,
        saveGraphConfigs
      }"
    >
      <v-container>
        <div class="utils" v-if="!isMobile">
          <v-btn outlined class="mb-1 mr-2" @click="dialog = true" color="blue">
            <v-icon class="mr-1">mdi-cog</v-icon>
            グラフ設定
          </v-btn>

          <v-btn outlined class="mb-1 mr-2" @click="csvModal = true">
            <v-icon class="mr-1">mdi-export-variant</v-icon>
            CSV出力
          </v-btn>
        </div>

        <export-csv-modal
          :modal="csvModal"
          @close="csvModal = false"
          @submit="exportCsv(measure, $event)"
        ></export-csv-modal>

        <series-graph
          :dataset="dataset"
          :title="measure.name"
          :height="isMobile ? windowHeight - 45 : 600"
          :yaxisUnit="measure.yaxis_unit"
          :shapes="shapes"
        ></series-graph>
      </v-container>

      <series-graph-config
        :measure="measure"
        :dialog="dialog"
        :notification="measure.notification"
        :addresses="measure.notification.addresses"
        @close="dialog = false"
        @save-config="
          saveGraphConfigs(measure);
          dialog = false;
        "
        :admin="isAdmin"
      ></series-graph-config>
    </div>
  </MeasureGraphContainer>
</template>

<script>
import { mapGetters } from "vuex";
import api from "@/api";

import ExportCsvModal from "@/components/ExportCsvModal.vue";
import SeriesGraph from "@/components/SeriesGraph.vue";
import SeriesGraphConfig from "@/components/SeriesGraphConfig.vue";

import MeasureGraphContainer from "@/components/MeasureGraphContainer";

export default {
  name: "MeasureGraph",
  components: {
    ExportCsvModal,
    SeriesGraph,
    SeriesGraphConfig,
    MeasureGraphContainer,
  },
  data() {
    return {
      dialog: false,
      csvModal: false,
      measureParams: null,
    };
  },
  props: {
    isMobile: { type: Boolean, default: () => false },
    windowHeight: { type: Number, default: () => 600 },
  },
  computed: {
    ...mapGetters("user", { isAdmin: "isAdmin" }),
  },
  methods: {
    exportCsv(measure, event) {
      api.measures.exportCsv(measure.id, event).then(() => {
        this.csvModal = false;
      });
    },
  },
};
</script>

<style></style>
